import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { AUTHORIZATION_ERROR_MESSAGE, subscribeToAuthorizationErrors } from "utils/apiErrors";

/**
 * App-wide notice for requests the backend rejected with a role gate (HTTP 403).
 *
 * Mounted once in `App`, so it fires no matter which page or component made the call — including
 * calls whose caller never handled the rejection at all.
 *
 * @returns {JSX.Element}
 */
const AuthorizationErrorNotice = () => {
  const [notice, setNotice] = useState({ open: false, message: AUTHORIZATION_ERROR_MESSAGE });

  useEffect(
    () =>
      subscribeToAuthorizationErrors(({ message }) =>
        setNotice({ open: true, message: message || AUTHORIZATION_ERROR_MESSAGE }),
      ),
    [],
  );

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setNotice(current => ({ ...current, open: false }));
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={notice.open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert severity="warning" variant="filled" onClose={handleClose} sx={{ width: "100%" }}>
        <AlertTitle>Keine Berechtigung</AlertTitle>
        {notice.message}
      </Alert>
    </Snackbar>
  );
};

export default AuthorizationErrorNotice;
